// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Codec, DecodeContext, RemoteObject, WebRPCError, ensureScalar } from "generated/webrpc";

export namespace MoodColor {
  export const refName = "mos.org.getty.color.MoodColor" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly hex: string,
    readonly style: MoodColorStyle,
  }
  export const defaults: Entity = {
    type: refName,
    hex: "",
    style: "UNSET",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.color.MoodColor");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["hex"] = ensureScalar(ctx, v["hex"], "string");
      {
        const ev = ensureScalar(ctx, v["style"], "string") || defaults["style"];
        if (!MoodColorStyleValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.color.MoodColorStyle`);
        }
        out["style"] = ev as any;
      }
      return out as any as Entity;
    }
  }();
}

export const MoodColorStyleValues = new Set([
  'UNSET' as const,
  'MEDIUM' as const,
  'DARK' as const,
  'LIGHT' as const,
]);
export type MoodColorStyle = typeof MoodColorStyleValues extends Set<infer U> ? U : never;

